import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UsrCustomerdetailsComponent } from '../usr-customerdetails/usr-customerdetails.component';
import { UsrActioncodeComponent } from '../usr-actioncode/usr-actioncode.component';
import { UsrAddnewaddressComponent } from '../usr-addnewaddress/usr-addnewaddress.component';
import { UsrAdhocscreenComponent } from '../usr-adhocscreen/usr-adhocscreen.component';
import { UsrAllocationhistoryComponent } from '../usr-allocationhistory/usr-allocationhistory.component';
import { UsrCustomerleaccountComponent } from '../usr-customerleaccount/usr-customerleaccount.component';
import { UsrDocumnetretrievalComponent } from '../usr-documnetretrieval/usr-documnetretrieval.component';
import { UsrExcelexportComponent } from '../usr-excelexport/usr-excelexport.component';
import { UsrFollowupsaveComponent } from '../usr-followupsave/usr-followupsave.component';
import { UsrFollowuptakeComponent } from '../usr-followuptake/usr-followuptake.component';
import { UsrFollowuptakeoneComponent } from '../usr-followuptakeone/usr-followuptakeone.component';
import { UsrFollowuptrailsComponent } from '../usr-followuptrails/usr-followuptrails.component';
import { UsrGurantordetailsComponent } from '../usr-gurantordetails/usr-gurantordetails.component';
import { UsrLoandetailsComponent } from '../usr-loandetails/usr-loandetails.component';
import { UsrLogoffusersComponent } from '../usr-logoffusers/usr-logoffusers.component';
import { UsrOverduedetailsoneComponent } from '../usr-overduedetailsone/usr-overduedetailsone.component';
import { UsrOverduedetailstwoComponent } from '../usr-overduedetailstwo/usr-overduedetailstwo.component';
import { UsrPaymentdetailsComponent } from '../usr-paymentdetails/usr-paymentdetails.component';
import { UsrPaymentdetailsoneComponent } from '../usr-paymentdetailsone/usr-paymentdetailsone.component';
import { UsrPhonedetailsComponent } from '../usr-phonedetails/usr-phonedetails.component';
import { UsrReferaccountComponent } from '../usr-referaccount/usr-referaccount.component';
import { UsrReportComponent } from '../usr-report/usr-report.component';
import { UsrRpoComponent } from '../usr-rpo/usr-rpo.component';
import { UsrScreenaccessoneComponent } from '../usr-screenaccessone/usr-screenaccessone.component';
import { UsrScreenaccesstwoComponent } from '../usr-screenaccesstwo/usr-screenaccesstwo.component';
import { UsrScreenaccessthreeComponent } from '../usr-screenaccessthree/usr-screenaccessthree.component';
import { UsrScreenaccesscontrolComponent } from '../usr-screenaccesscontrol/usr-screenaccesscontrol.component';
import { UsrScreenaccesscontroloneComponent } from '../usr-screenaccesscontrolone/usr-screenaccesscontrolone.component';
import { UsrScreenaccesscontroltwoComponent } from '../usr-screenaccesscontroltwo/usr-screenaccesscontroltwo.component';
import { UsrScreenaccesscontrolthreeComponent } from '../usr-screenaccesscontrolthree/usr-screenaccesscontrolthree.component';
import { UsrUserdetailsComponent } from '../usr-userdetails/usr-userdetails.component';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
import { UsrAllocationdetailComponent } from '../usr-allocationdetail/usr-allocationdetail.component';
import { UsrCollateraldetailssComponent } from './../usr-collateraldetailss/usr-collateraldetailss.component';
import { UsrWorkflowComponent } from './../usr-workflow/usr-workflow.component';
import { UsrCollectionRecordingComponent } from './../usr-collection-recording/usr-collection-recording.component';
import { UsrCollectionRecordingMainListComponent } from './../usr-collection-recording-main-list/usr-collection-recording-main-list.component';
import { UsrSettlementRecordingMainListComponent } from './../usr-settlement-recording-main-list/usr-settlement-recording-main-list.component';

import { UsrPoliceCaseComponent } from './../usr-police-case/usr-police-case.component';

import { UsrSkipTracingMainComponent } from './../usr-skip-tracing-main/usr-skip-tracing-main.component';
import { UsrFiledVisitMainComponent } from './../usr-filed-visit-main/usr-filed-visit-main.component';
import Swal from 'sweetalert2';
import { UsrCustomerExplosureComponent } from './../usr-customer-explosure/usr-customer-explosure.component';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { UsrNewFollowupComponent } from '../usr-new-followup/usr-new-followup.component';
import { ApiService } from 'src/app/api.service';
import { NewFieldVisitComponent } from '../new-field-visit/new-field-visit.component';

import * as moment from 'moment';
import { AgGridAngular } from 'ag-grid-angular';
import { UsrStatcardComponent } from '../usr-statcard/usr-statcard.component';
import { OverlayPanel } from 'primeng/overlaypanel';
class contact{
  home_Number: string;
      mobile_Number: string;
      office_Number: string;
      bank_id: string;
      product_id: string;
      porfolio_id: string;
      bucket_id:string;
      finterstal_id: string;
      passport_no: string;
      acc_no: string;
}
@Component({
  selector: 'app-usr-contactrecording',
  templateUrl: './usr-contactrecording.component.html',
  styleUrls: ['./usr-contactrecording.component.css']
})
export class UsrContactrecordingComponent implements OnInit {
  @ViewChild('agGrid', { static: false }) agGrid: AgGridAngular;
  FollowUpcolumnDefs = [
    // {headerName: 'ID', field: '_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    { headerName: 'Log Date', field: 'log_date', resizable: true, sortable: true, filter: true },
    { headerName: 'Log Type', field: 'log_type', resizable: true, sortable: true, filter: true },
    { headerName: 'FollowUp Date', field: 'fdate', resizable: true, sortable: true, filter: true },
    { headerName: 'Main Status', field: 'mstatus', resizable: true, sortable: true, filter: true },
    { headerName: 'Sub Status', field: 'substatus', resizable: true, sortable: true, filter: true },
    { headerName: 'Remarks', field: 'remarks', resizable: true, sortable: true, filter: true },
    { headerName: 'Bank Code', field: 'bcode', resizable: true, sortable: true, filter: true },
    { headerName: 'Action To Taken', field: 'actiontotake', resizable: true, sortable: true, filter: true },

    {
      headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true,
      cellRenderer: (data) => {
        if (data.value && data.value !== '') {
          return `<a href="${data.value}" target="_blank" style="color: #007bff; text-decoration: none;">View</a>`;
        }
        return '';
      }
    },
    {
      headerName: 'Agent name', field: 'createdby', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return data.value.name;
      }
    },
    // {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Passport Numbet', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {
      headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Options', width: 120, cellRenderer: function (params) {
        return "";
      }
    },
  ];

  SettlementcolumnDefs = [
    { headerName: 'ID', field: '_id', width: 250, checkboxSelection: true, headerCheckboxSelection: true, sortable: true, filter: true },
    { headerName: 'Settlement Type', field: 'settlement_type', resizable: true, sortable: true, filter: true },
    { headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Current Total', field: 'current_total', resizable: true, sortable: true, filter: true },
    { headerName: 'Payment Date', field: 'payment_date', resizable: true, sortable: true, filter: true },
    { headerName: 'Amount', field: 'amount', resizable: true, sortable: true, filter: true },
    { headerName: 'No of Installment', field: 'no_of_installments', resizable: true, sortable: true, filter: true },
    { headerName: 'First Installment', field: 'fst_installment', resizable: true, sortable: true, filter: true },
    { headerName: 'Approval Status', field: 'approval_status', resizable: true, sortable: true, filter: true },
    { headerName: 'Details', field: 'details_notes', resizable: true, sortable: true, filter: true },
    {
      headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true,
      cellRenderer: (data) => {
        if (data.value && data.value !== '') {
          return `<a href="${data.value}" target="_blank" style="color: #007bff; text-decoration: none;">View</a>`;
        }
        return '';
      }
    },
    // {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    // {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    // {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Passport Numbet', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {
      headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
  ];
  PaymentscolumnDefs = [
    { headerName: 'ID', field: '_id', width: 250, checkboxSelection: true, headerCheckboxSelection: true, sortable: true, filter: true },
    { headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Payment Date', field: 'payment_date', resizable: true, sortable: true, filter: true },
    { headerName: 'Payment Amount', field: 'payment_amount', resizable: true, sortable: true, filter: true },
    { headerName: 'Due amount', field: 'due_amount', resizable: true, sortable: true, filter: true },
    { headerName: 'Paid Date', field: 'paid_date', resizable: true, sortable: true, filter: true },
    { headerName: 'Last Payment Date', field: 'last_paid_amount', resizable: true, sortable: true, filter: true },
    { headerName: 'Next Payment Date', field: 'next_payment_date', resizable: true, sortable: true, filter: true },
    {
      headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true,
      cellRenderer: (data) => {
        if (data.value && data.value !== '') {
          return `<a href="${data.value}" target="_blank" style="color: #007bff; text-decoration: none;">View</a>`;
        }
        return '';
      }
    },
    // {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    // {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    // {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Passport Numbet', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {
      headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
  ];


  FieldVisitcolumnDefs = [
    { headerName: 'ID', field: '_id', width: 250, checkboxSelection: true, headerCheckboxSelection: true, sortable: true, filter: true },
    { headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true },
    { headerName: 'Territory Name', field: 'fieldvisitterritory', resizable: true, sortable: true, filter: true },
    { headerName: 'Area Name', field: 'fieldvisitarea', resizable: true, sortable: true, filter: true },
    { headerName: 'First Address', field: 'firstaddress', resizable: true, sortable: true, filter: true },
    { headerName: 'Second Address', field: 'secondaddress', resizable: true, sortable: true, filter: true },
    { headerName: 'Requested Date', field: 'fvrqdate', resizable: true, sortable: true, filter: true },
    { headerName: 'Remarks', field: 'remarks', resizable: true, sortable: true, filter: true },
    {
      headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true,
      cellRenderer: (data) => {
        if (data.value && data.value !== '') {
          return `<a href="${data.value}" target="_blank" style="color: #007bff; text-decoration: none;">View</a>`;
        }
        return '';
      }
    },
    // {headerName: 'Status', field: 'status', resizable: true, sortable: true, filter: true},
    { headerName: 'Approval Status', field: 'approval_status', resizable: true, sortable: true, filter: true },
    { headerName: 'FV Done Date', field: 'FV_Done_Date', resizable: true, sortable: true, filter: true },
    { headerName: 'Numbers Obtained', field: 'Numbers_Obtained', resizable: true, sortable: true, filter: true },
    { headerName: 'FV Feedback', field: 'FV_Feedback', resizable: true, sortable: true, filter: true },
    // {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    // {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    // {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Passport Numbet', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {
      headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
    {
      headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
        return moment(data.value).format('LLLL');
      }
    },
  ];
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new UntypedFormControl(this.positionOptions[0]);
  rows = [];
  searchQR: any;
  value1: any;
  del: boolean = false;
  show: any;
  assets: boolean = false;
  payment: boolean = false;
  displayPosition: boolean = false;
  multipleAccountInformation = [];
  loadedRecord: any;
  row: any;
  column: any;
  dataList: any;
  dataList1: any;
  CustomerData: any;
  FollowUpList: any = [];
  LinkedAccounts: any[];
  TracingToolsList: any = [];
  mapped_details = [];
  upmapped_details = [];


  mobile_Number: any;
  office_Number: any;
  home_Number:any;
  SettlementList: any = [];
  userFilter: any = { settlement_type: '' };
  PaymentsList: any = [];
  FieldVisitList: any = [];
  RemarksList: any = [];
  Reallocation: any = [];
  CIDCIFlist: any[];
  original_portfolio_list: any;
  origianl_bank_list: any;
  original_user_list: any;

  additional_data: any;
  CustomernewData: any;

  check_allocation_status = false;


  Linklist = [];
  link = "";
  tracingtool = "";
  enterpassword = "";
  data_hide = false;
  follow_up_data: any;
  edit_view = false;
  ContectdetailsForm: any;
  Contectdetails: any;
  ContectDetails: any;


  @ViewChild('contactDetails', { static: false }) contactDetails: OverlayPanel;

  @ViewChild('EditPanel', { static: false }) EditPanel: OverlayPanel;
  formValues: any;
  constructor(
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private router: Router,
    public dialog: MatDialog,
    private _api: ApiService,
    private formBuilder: UntypedFormBuilder
  ) {
    this.ContectdetailsForm = this.formBuilder.group({
      home_Number: [''],
      mobile_Number: ['', Validators.required],
      office_Number: [''],
      bank_id: [''],
      finterstal_id: [''],
      customer_details: [''],
      passport_no: [''],
      portfolio_id: [''],
      product_id: [''],
      _id:[]
    });
  }



  ngOnInit(): void {
    // window.scrollTo(0, 0);
    this.rows = [{ type: "Dog", name: "dog1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" }];

    this.multipleAccountInformation = [
      { LoanNumber: "123456", Product: "Auto Loan", LoanAmount: "10,00000", OutstandingAmount: "50,0000", TotalOverdueAmount: "2000", NextInstallmentAmount: "20000", NextInstallmentDueDate: "20-10-2020", Bucket: "23", MinimumamountforBucketmovement: "5", UnitCode: "BC23", },
      { LoanNumber: "789654", Product: "NA", LoanAmount: "NA", OutstandingAmount: "NA", TotalOverdueAmount: "NA", NextInstallmentAmount: "NA", NextInstallmentDueDate: "NA", Bucket: "NA", MinimumamountforBucketmovement: "NA", UnitCode: "NA", },
      { LoanNumber: "786786", Product: "Auto Loan", LoanAmount: "15,00000", OutstandingAmount: "55,0000", TotalOverdueAmount: "4000", NextInstallmentAmount: "40000", NextInstallmentDueDate: "20-01-2021", Bucket: "32", MinimumamountforBucketmovement: "5", UnitCode: "BC23", },
    ]


    if (this.storage.get("_storedRecord")) {
      this.loadedRecord = this.storage.get("_storedRecord")
      this.dataList = this.loadedRecord.dataList;
      console.log(this.dataList ,"this.dataList");

      if (this.loadedRecord.keyvalue.customer_details[0].insert_id != undefined) {
        const tempdata = this.loadedRecord.keyvalue.customer_details;
        this.CustomerData = tempdata[0];
      } else {
        const tempdata = this.loadedRecord.keyvalue.customer_details;
        this.CustomernewData = JSON.parse(tempdata[0]);
        this.CustomerData = this.CustomernewData[0];
      }



      // Assigned Unique ID
      localStorage.setItem("Account_ID", this.loadedRecord.keyvalue.acc_no);
      localStorage.setItem("Customer_ID", this.loadedRecord.keyvalue.customer_id);
      localStorage.setItem("Passport_Number", this.loadedRecord.keyvalue.passport_no);
      localStorage.setItem("Portfolio_ID", this.loadedRecord.keyvalue.porfolio_id);
      localStorage.setItem("Product_ID", this.loadedRecord.keyvalue.product_id);
      localStorage.setItem("Client_ID", this.loadedRecord.keyvalue.client_id);
      localStorage.setItem("Bucket_ID", this.loadedRecord.keyvalue.bucket_id);
      localStorage.setItem("Bank_ID", this.loadedRecord.keyvalue.bank_id);
      localStorage.setItem("Fintrestle_ID", this.loadedRecord.keyvalue.finterstal_id);

      localStorage.setItem("StopFollowUp", this.loadedRecord.keyvalue.stop_follow_up_status);
      localStorage.setItem("MarkCompleted", this.loadedRecord.keyvalue.mark_complete_status);
      localStorage.setItem("AccBlock", this.loadedRecord.keyvalue.acc_block_status);
      localStorage.setItem("Widthdraw", this.loadedRecord.keyvalue.withdraw_status);

      const LinkedData = {
        bucket_id: this.loadedRecord.keyvalue.bucket_id,
        passport_no: this.loadedRecord.keyvalue.passport_no

      }
      const MappedData = {
        passport_no: this.loadedRecord.keyvalue.passport_no
      }

      const MappedData2 = {
        bank_id: this.loadedRecord.keyvalue.bank_id,
        product_id: this.loadedRecord.keyvalue.product_id,
        porfolio_id: this.loadedRecord.keyvalue.porfolio_id,
        bucket_id: this.loadedRecord.keyvalue.bucket_id,
        finterstal_id: this.loadedRecord.keyvalue.finterstal_id,
        passport_no: this.loadedRecord.keyvalue.passport_no,
        acc_no: this.loadedRecord.keyvalue.acc_no,
      }

      const reallocation = {
        bank_id: this.loadedRecord.keyvalue.bank_id,
        product_id: this.loadedRecord.keyvalue.product_id,
        porfolio_id: this.loadedRecord.keyvalue.porfolio_id,
        bucket_id: this.loadedRecord.keyvalue.bucket_id,
        finterstal_id: this.loadedRecord.keyvalue.finterstal_id,
        passport_no: this.loadedRecord.keyvalue.passport_no,
        acc_no: this.loadedRecord.keyvalue.acc_no,
      }

      this._api.getlist_tracingtools().subscribe(data => {
        if (data['Code'] == 200) {
          this.TracingToolsList = data['Data'];
        } else {
          this.TracingToolsList = [];
        }
      });


      this._api.getLinkedaccounts(LinkedData).subscribe(data => {
        if (data['Code'] == 200) {
          this.LinkedAccounts = data['Data'];
        } else {
          this.LinkedAccounts = [];
        }
      });
      this._api.getMappedaccounts(MappedData2).subscribe(data => {
        if (data['Code'] == 200) {
          let MappedAccounts = data['Data'];
          this.mapped_details = MappedAccounts.mapped_details;
          this.mapped_details.forEach(element => {
            let name = JSON.parse(element.customer_details[0]);
            element.agent_name = name[0].AGENT;
            // element.principle_amt = name[0].PRINCIPLE_AMT;
            element.Customer_Name = name[0].Customer_Name;
            element.total_out_standing =  name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : name[0].total_out_standing;
          });
          this.upmapped_details = MappedAccounts.upmapped_details;
          console.log("this.mapped_details",this.mapped_details);
          console.log("this.upmapped_details ",this.upmapped_details);
        } else {
          this.mapped_details = [];
          this.upmapped_details = [];
        }
      });
      this._api.getCIDCIF(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
        if (data['Code'] == 200) {
          this.CIDCIFlist = data['Data'];
        } else {
          this.CIDCIFlist = [];
        }
      });
      this._api.getlist_new_FollowUp(localStorage.getItem("Passport_Number")).subscribe(data => {
        if (data['Code'] == 200) {
          this.FollowUpList = data['Data'];
          console.log("this.FollowUpList",this.FollowUpList);
          console.log("rtydtfg",localStorage.getItem("Passport_Number"));

        } else {
          this.FollowUpList = [];
        }
      });
      this._api.getlist_new_settlement(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
        if (data['Code'] == 200) {
          this.SettlementList = data['Data'];
        } else {
          this.SettlementList = [];
        }
      });
      this._api.getlist_new_payment(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
        if (data['Code'] == 200) {
          this.PaymentsList = data['Data'];
          this.PaymentsList.sort((a, b) => {
            return <any>new Date(b.Date) - <any>new Date(a.Date);
          });
        } else {
          this.PaymentsList = [];
        }
      });
      this._api.getlist_new_contect_details(localStorage.getItem("Fintrestle_ID")).subscribe((data:any) => {
        if (data['Code'] == 200) {
          this.ContectDetails = data['Data'];
          console.log(this.ContectDetails,"this.ContectDetails");

        } else {
          this.ContectDetails = null;
        }
      });
      this._api.getlist_new_fieldvisit(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
        if (data['Code'] == 200) {
          this.FieldVisitList = data['Data'];
          this.FieldVisitList.sort((a, b) => {
            return <any>new Date(b.Date) - <any>new Date(a.Date);
          });
          // console.log("this.FieldVisitList ",this.FieldVisitList );

        } else {
          this.FieldVisitList = [];
        }
      });
      this._api.get_remarks_list(localStorage.getItem("Fintrestle_ID")).subscribe((data: any) => {
        if (data['Code'] == 200) {
          this.RemarksList = data['Data'];
          this.RemarksList.sort((a, b) => {
            return <any>new Date(b.Date) - <any>new Date(a.Date);
          });
        } else {
          this.RemarksList = [];
        }
      });
      this._api.get_reallocation_list(reallocation).subscribe(data => {
        if (data['Code'] == 200) {
          this.Reallocation = data['Data'];
          this.Reallocation.sort((a, b) => {
            return <any>new Date(b.Date) - <any>new Date(a.Date);
          });
        } else {
          this.Reallocation = [];
        }
      });

      let logindetail = this.getFromLocal("login_Details");
      // console.log(logindetail);
      let values = {
        "finterstal_id": this.loadedRecord.keyvalue.finterstal_id,
        "assigned_to": logindetail._id
      }
      // console.log(values);
      this._api.check_allocation_status(values).subscribe(data => {
        if (data['Code'] == 200) {
          let check_allocation = data['Data'];
          // console.log(check_allocation);
          if (check_allocation == null) {
            this.check_allocation_status = false;
          } else {
            this.check_allocation_status = true;
          }
          // console.log(this.check_allocation_status);
        } else {
          this.Reallocation = [];
        }
      });
      this.ContectDetails
      let a = {
        CUSTOMER_ID: this.loadedRecord.keyvalue.finterstal_id,
        passport_no: this.loadedRecord.keyvalue.passport_no,
        Account_No: this.loadedRecord.keyvalue.acc_no,
        // home_Number: this.ContectDetails.home_Number,
        // mobile_Number: this.ContectDetails.mobile_Number,
        // office_Number: this.ContectDetails.office_Number,

      }
      console.log("aaa",a);

      this._api.get_additionl_detail(a).subscribe(data => {
        if (data['Code'] == 200) {
          let c = data['Data'];
          if (c.length == 0) {
            this.dataList1 = [];
          } else {
// debugger
            // console.log(convDatav['length']);
            var jsonObject = c[0];
            var keyCount = Object.keys(jsonObject).length;
            // console.log(keyCount);
            let dataList = [];
            for (let i = 0; i < c.length; i++) {
              for (let i = 0; i < keyCount; i++) {
                var key = Object.keys(jsonObject)[i];
                if (key == "_id" || key == "CUSTOMER_ID" || key == "Bank_id" || key == "Portfolio_id" || key == "Portfolio_ID" || key == "" || key == "NATION_NAME" || key == "product_id"  || key == "home_Number" || key == "" || key == "mobile_Number" || key == "office_Number") {

                } else {
                  var value = jsonObject[key];
                  dataList.push({ column: key, row: value });
                }
              }
            }
            this.dataList1 = dataList;
            this.additional_data = { dataList, "keyvalue": data }
            // this.storage.set("_storedRecord",{dataList,"keyvalue":data});


          }




        } else {
          this.Reallocation = [];
        }
      });
    } else {
      this.loadedRecord = [];
    }





    this.portfolio_list_get();
    this.bank_list_get();
    this.user_list_get();
    this. Contectdetail()

// console.log("this. Contectdetail()",this. Contectdetail());


  }


  addContect() {
    // debugger
    var ContectdetailsForm = this.ContectdetailsForm.value
    let contect = {
      home_Number: ContectdetailsForm.home_Number,
      mobile_Number: ContectdetailsForm.mobile_Number,
      office_Number: ContectdetailsForm.office_Number,
      // customer_details: this.CustomerData ,
      bank_id: this.loadedRecord.keyvalue.bank_id,
      product_id: this.loadedRecord.keyvalue.product_id,
      porfolio_id: this.loadedRecord.keyvalue.porfolio_id,
      bucket_id: this.loadedRecord.keyvalue.bucket_id,
      finterstal_id: this.loadedRecord.keyvalue.finterstal_id,
      passport_no: this.loadedRecord.keyvalue.passport_no,
      acc_no: this.loadedRecord.keyvalue.acc_no,
    }
    console.log(contect,"contect");

    this._api.create_new_contect_details(contect).subscribe((data:any) => {

      this.Contectdetails = data
      console.log("this.Contectdetails", this.Contectdetails);
      this.contactDetails.hide();
    });


  }

  showContactDetails(data,item) {
    console.log(":data",item);

    // debugger// Get the contact details from the form
    let formValues = item;
    // console.log(formValues);
    this.formValues = data;
    console.log("123",this.formValues);
    // Set the contact details to the form
    this.ContectdetailsForm.patchValue({

      home_Number: formValues.home_Number,
      mobile_Number: formValues.mobile_Number,
      office_Number: formValues.office_Number,
      bank_id: formValues.bank_id,
      product_id: formValues.product_id,
      porfolio_id: formValues.porfolio_id,
      bucket_id: formValues.bucket_id,
      finterstal_id: formValues.finterstal_id,
      passport_no: formValues.passport_no,
      acc_no: formValues.acc_no,
      _id: formValues._id,
      view : true
    });

    // Show the overlay panel
    console.log(this.ContectdetailsForm.value);

    // Check if the contactDetails object is defined and its show() method is defined
    if (this.EditPanel.show && typeof this.EditPanel.show === 'function') {
      this.EditPanel.show(data);
    } else {
      console.error("The contactDetails object is not properly defined or its show() method is not defined");
    }
  }
  // UpdateContectdetail() {
  //   // debugger
  //   this._api.update_new_contect_details(localStorage.getItem("Fintrestle_ID")).subscribe((data:any) => {
  //     if (data['Code'] == 200) {
  //       this.ContectDetails = data['Data'];
  //       console.log(this.ContectDetails,"this.ContectDetails");

  //     } else {
  //       this.ContectDetails = null;
  //     }

  //   });
  // }
  updateContect() {
    // retrieve the updated contact details from the form
console.log("this.formValues",this.formValues);

    // update the contact record in the database using the API
    this._api.update_new_contect_details(this.ContectdetailsForm.value).subscribe((data:any) => {
      if (data['Code'] == 200) {
              this.ContectDetails = data['Data'];
              console.log(this.ContectDetails,"this");

            } else {
              this.ContectDetails = null;
            }
    });

    // hide the overlay panel
    this.EditPanel.hide();
  }
  refresh() {
    this._api.getlist_new_FollowUp(localStorage.getItem("Fintrestle_ID")).subscribe(data => {
      if (data['Code'] == 200) {
        this.FollowUpList = data['Data'];
      } else {
        this.FollowUpList = null;
      }
    });
  }



  // close1() {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: 'You want to close it!',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then((result) => {
  //     if (result.value) {
  //       this.ContectdetailsForm.closeAll();
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //     }
  //   })

  // }

  Contectdetail() {
    // debugger
    this._api.getlist_new_contect_details(localStorage.getItem("Fintrestle_ID")).subscribe((data:any) => {
      if (data['Code'] == 200) {
        this.ContectDetails = data['Data'];
        console.log(this.ContectDetails,"this.ContectDetails");

      } else {
        this.ContectDetails = null;
      }

    });
  }
  clearContectdetail(id: string) {
    this._api.delete_new_contect_details(id).subscribe(() => {
      this.Contectdetail();
    });
  }
  edit_track(data) {
    this.Linklist = [];
    this.follow_up_data = data;
    this.Linklist = data.tracinglink;
    this.tracingtool = data.tracingtool;
    this.edit_view = true;
  }

  delete_track_tool(index) {
    this.Linklist.splice(index, 1);
  }

  edit_submit() {
    let data = {
      _id: this.follow_up_data._id,
      tracingtool: this.tracingtool,
      tracinglink: this.Linklist
    }
    // console.log(data);
    this._api.update_new_FollowUp1(data).subscribe(data => {
      // console.log(data['Code']);
      this.edit_view = false;
      if (data['Code'] == 200) {

        alert(data['Message']);

        this.link = '';
        this.tracingtool = '';
        this.Linklist = [];
        this.refresh();
        this.edit_view = false;
      } else {
        alert(data['Message']);

        this.link = '';
        this.tracingtool = '';
        this.Linklist = [];
        this.refresh();
        this.edit_view = false;
      }
    });
  }



  getFromLocal(key): any {
    return this.storage.get(key);
  }


  user_list_get() {

    let a = {
      client_id: this.getFromLocal("Client_ID")
    }
    this._api.user_details_list().subscribe(
      (response: any) => {
        this.original_user_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );

  }

  addnewLink() {
    this.Linklist.push({ link: this.link, tool: this.tracingtool });
    // this.FollowUpForm.patchValue({
    //   tracinglink:this.Linklist
    // })
    this.link = '';
    this.tracingtool = '';
  }

  portfolio_list_get() {
    let a = {
      client_id: this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }


  bank_list_get() {
    let a = {
      client_id: this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.origianl_bank_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }



  client_form() {
    this.router.navigateByUrl('/admin_panel/client-form')
  }
  profile() {
    this.router.navigateByUrl('/admin_panel/Client_profile')
  }

  onTypeChange(event) {
    this.userFilter.settlement_type = event.target.value;
  }

  showPositionDialog() {
    this.displayPosition = true;
  }


  viewLinkedaccounts() {

  }


  getScard() {
    const dialogRef = this.dialog.open(UsrStatcardComponent, {
      height: '650px',
      width: '90%', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show1';
  }

  show1() {
    const dialogRef = this.dialog.open(UsrNewFollowupComponent, {
      height: '650px',
      width: '90%', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show1';
    // this.followuptake = true;
    // this.selectedIndex = 21;
  }


  show2() {
    const dialogRef = this.dialog.open(UsrWorkflowComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show2';
    // this.workflow = true;
    // this.selectedIndex = 22;
  }
  show3() {
    const dialogRef = this.dialog.open(UsrCollectionRecordingMainListComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show3';
  }
  show4() {
    const dialogRef = this.dialog.open(UsrSettlementRecordingMainListComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show4';
  }

  show5() {
    const dialogRef = this.dialog.open(UsrPoliceCaseComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show5';
  }
  show6() {
    const dialogRef = this.dialog.open(UsrCustomerleaccountComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  show7() {
    const dialogRef = this.dialog.open(UsrOverduedetailsoneComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  show8() {
    const dialogRef = this.dialog.open(UsrSkipTracingMainComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show8';
  }
  show9() {
    const dialogRef = this.dialog.open(NewFieldVisitComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
    this.show = 'show9';
  }
  show10() {
    const dialogRef = this.dialog.open(UsrPaymentdetailsComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  show11() {
    const dialogRef = this.dialog.open(UsrPhonedetailsComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  show12() {
    const dialogRef = this.dialog.open(UsrOverduedetailstwoComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  show13() {
    const dialogRef = this.dialog.open(UsrCustomerExplosureComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  show14() {
    const dialogRef = this.dialog.open(UsrAllocationhistoryComponent, {
      height: '600px', disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  close() {
    this.contactDetails.hide();
  }
  close1() {
    this.EditPanel.hide();
  }

  openworklist() {
    Swal.fire({
      // title: 'Are you sure?',
      text: 'You want to open in a new tab!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        let url: any = '#/admin_panel/accounts/accounts';
        window.open(url, '_blank');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.router.navigateByUrl('/admin_panel/accounts/accounts')
      }
    })

  }

  openworklist1() {
    Swal.fire({
      // title: 'Are you sure?',
      text: 'You want to make a call',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
    });

  }

  openworklist2() {
    Swal.fire({
      // title: 'Are you sure?',
      text: 'You want to send the mail',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {

    });

  }


  asset() {
    this.assets = !this.assets;
  }
  pay() {
    this.payment = !this.payment;
  }


  check_value() {
    if (this.enterpassword == '12345') {
      this.data_hide = true;
    } else {
      this.data_hide = false;
      alert('Invalid Key');
    }
  }
}


